import { tracked } from "@glimmer/tracking";
import Service, { service } from "@ember/service";

export default class EnforceEditReason extends Service {
  @service composer;

  @tracked enforceReason = false;

  toggleState(state) {
    this.composer.setProperties({
      disableSubmit: state,
      showEditReason: state,
    });
    this.enforceReason = state;
  }

  get composerModel() {
    return this.composer.model;
  }

  get isEditMode() {
    return this.composerModel?.action === "edit";
  }

  get isCategoryRequiringEditReason() {
    return !!this.composerModel?.topic?.category?.custom_fields
      ?.waze_require_edit_reason;
  }

  get isPostWiki() {
    return !!this.composerModel?.post?.wiki;
  }

  get shouldEnforce() {
    return (
      this.isEditMode && this.isCategoryRequiringEditReason && this.isPostWiki
    );
  }
}
